// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'import.importButton.import': 'Importar',
  },
  en: {
    'import.importButton.import': 'Import',
  },
  es: {
    'import.importButton.import': 'Importar',
  },
}
